module.exports = __webpack_public_path__ + "img/u.bb0f628b.jpg";